<template>
     <el-dialog title="添加岗位" :visible.sync="addPostDialog" width="25%" top="15vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false @close="closeDialog" :show-close= false>
        <el-card>
            <el-form ref="detailDialog" :model="request" label-width="80px">
                <el-form-item label="岗位名称" required=true><el-input v-model="request.name" clearable style="width: 250px"></el-input></el-form-item>
                <el-form-item label="岗位权限">
                    <el-select v-model="request.functionIds" multiple collapse-tags placeholder="请选择权限"  clearable style="width: 250px">
                        <el-option v-for="item in functions" :key="item.functionId" :label="item.name" :value="item.functionId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="addPostDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="addPost">确定</el-button>
        </span>
     </el-dialog>
</template>
<script>
import {getFunction, addPost} from '../../api/sys/position.js'
export default {
    data(){
        return {
            addPostDialog: false,
            request: {
                name: '',
                functionIds: []
            },
            functions: [] 
        }
    },
    methods: {
        init(){
            this.addPostDialog = true;
            //获取权限列表
            getFunction(null).then(result=>{
                this.functions = result.data;
            })
        },
        addPost(){
            if(this.request.name === null || this.request.name === ""){
                this.$message({
                    message: "岗位名称不能为空",
                    type: "error",
                    duration: 1500,
                });
                return;
            }
            addPost(this.request).then(result=>{
                this.$emit("add-succeed");
                this.$message({
                    message: "添加成功",
                    type: "success",
                    duration: 1500,
                });
                this.addPostDialog = false;
            })
        },
        closeDialog(){
            this.addPostDialog =  false;
            this.request.functionIds = [];
            this.functions = [];
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/sys/addPost.vue